module.exports = __webpack_public_path__ + "static/media/mc.f177a131.svg";